import * as api from '../api';
import { Model, Expand } from '../common';
import { Membership } from './Membership';

export class NotAuthorized extends Error {
    constructor() {
        super("Not authorized");
    }
}

@Model('User')
export class User extends api.ApiUser {
    @Expand() membership : Membership;
    assumed : boolean;

    static ROOT_URL = '/users';
}